var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brand",style:({ 
    'background-image': ("url(" + _vm.background + "), url(" + _vm.backgroundHover + ")"),
    '--bg-hover':("url(" + _vm.backgroundHover + ")")
  })})}
var staticRenderFns = []

export { render, staticRenderFns }